module.exports = __webpack_public_path__ + "static/media/twitter-icon.36e93d8b.svg";